import { render, staticRenderFns } from "./AgentMerchantFlow.vue?vue&type=template&id=37fe6d86&scoped=true&"
import script from "./AgentMerchantFlow.vue?vue&type=script&lang=js&"
export * from "./AgentMerchantFlow.vue?vue&type=script&lang=js&"
import style0 from "./AgentMerchantFlow.vue?vue&type=style&index=0&id=37fe6d86&scoped=true&lang=css&"
import style1 from "./AgentMerchantFlow.vue?vue&type=style&index=1&id=37fe6d86&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe6d86",
  null
  
)

export default component.exports